import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";
import { type AuthToken } from "utils/authUtils";

type SyncDesignImagesRequest = {
  proposalLargeUrl: string;
  proposalSmallUrl: string;
  pinsUrl?: string;
};

const transferDesignImages = async (
  authToken: AuthToken,
  lightmileProjectId: string,
  sourceImageUrls: SyncDesignImagesRequest
): Promise<void> => {
  return AmplifyPost(
    "Sync Design Images",
    "OfferExpApi",
    `/lightmile-project/${lightmileProjectId}/transfer-design-images?authType=${authToken.type}`,
    {
      headers: {
        Authorization: `Bearer ${authToken.token}`,
      },
      body: sourceImageUrls,
    },
    logger
  );
};

export { transferDesignImages };
